import React, { useContext } from 'react'
import { Card, Col, DateFormat, enhancedFetch, Icon, JourneyAppContext, RadioInput, Row, useAlert } from 'journey-ui'
import { Warning } from 'phosphor-react'
import { ItemPageContext } from '../../contexts/ItemPageContext'
import { calculateItemToppingPrice, getRuleToppingNames, isIncludedTopping, money, sum } from '../../helpers'
import { CardTitle } from '../../pages/item/[slug]'
import { getToppingsInRules } from './TileCard'
import { AppContext } from '../../contexts/AppContext'

interface Props {

}

function getAddonItems(addon: Addon, order: Order) {
  return order?.items?.filter((i) => i.addon_hash_id === addon.hash_id) ?? []
}

export const WarningCheck: React.FC<Props> = () => {
  const { form, item, tiles, rules } = useContext(ItemPageContext)

  /* Are we missing toppings that need to be selected? */
  const invalidRules = rules
    .filter((r) => r.min > getToppingsInRules(rules, form).length)

  if (invalidRules.length <= 0) {
    return null
  }

  return (
    <Card className="bg-yellow-400 p-4 flex items-center space-x-4">
      <Icon className="md:w-12 md:h-12 flex-shrink-0" src={Warning} />
      <div className="flex items-center">
        {item.parent_name ? `This item was included with your "${item.parent_name}" and it` : 'This item'}
        {' '}
        requires you to make a selection of
        {' '}
        {invalidRules.map((r) => getRuleToppingNames(r, tiles).toLowerCase()).join(' ')}
        .
      </div>
    </Card>
  )
}
